import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

const ComicCard = ({ comic }: ComicCardProps) => {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-secondary-200/60 hover:border-primary-300 transition-all duration-300"
      data-product-shop
    >
      {/* Cover Image */}
      <div className="relative overflow-hidden" style={{ aspectRatio: '3/4' }}>
        <img
          src={comic.coverUrl}
          alt={comic.title}
          title={`${comic.title} - 汗汗漫画韩国漫画免费在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
        />
        {/* Status Badge */}
        <span
          className={`absolute top-2 right-2 px-2 py-0.5 rounded-full text-xs font-medium ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}
        >
          {comic.status}
        </span>
        {/* Rating */}
        <div className="absolute bottom-2 left-2 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm text-background-50 px-2 py-0.5 rounded-full text-xs">
          <span className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-accent-400 text-[10px]"></i>
          </span>
          {comic.rating}
        </div>
      </div>

      {/* Info */}
      <div className="p-3">
        <h3 className="font-heading text-sm text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors mb-1.5">
          {comic.title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-user-line text-[10px]"></i>
            </span>
            {comic.author}
          </span>
          <span>
            共{comic.totalChapters}话
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ComicCard;